import { render, staticRenderFns } from "./widgetBarchart.vue?vue&type=template&id=1953c260&scoped=true&"
import script from "./widgetBarchart.vue?vue&type=script&lang=js&"
export * from "./widgetBarchart.vue?vue&type=script&lang=js&"
import style0 from "./widgetBarchart.vue?vue&type=style&index=0&id=1953c260&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1953c260",
  null
  
)

export default component.exports